import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from './PrivateRoute';

import { HomePage, LoginPage, ErrorPage, SystemAccessPage } from 'app/pages';
import {
  ChangePasswordPage,
  RecoverPasswordPage,
  ResetPasswordPage,
  ConfirmationEmailPage,
} from 'user/pages';
import { HOME_PATH } from '../routes';
import {
  CHANGE_PASSWORD_PATH,
  PASSWORD_EXPIRED_PATH,
  LOGIN_PATH,
  RECOVER_PASSWORD_PATH,
  FORBIDDEN_PATH,
  RESET_PASSWORD_PATH,
  CONFIRMATION_EMAIL_PATH,
  CREATION_USERS_PATH,
  LIST_USERS_PATH,
  DETAIL_USERS_PATH,
  EDIT_USERS_PATH,
  SERVICE_UNAVAILABLE_PATH,
  SYSTEM_ACCESS_PATH,
} from 'user/routes';
import {
  ACCOUNT_TOTALS_BY_ACCOUNT_PATH,
  ACCOUNT_TOTALS_PATH,
  ACCOUNT_AUTHORIZATIONS_PATH,
  ACCOUNT_REFUND_PATH,
  ACCOUNT_DISTRIBUTION_PATH,
  ACCOUNT_TRANSFER_HISTORY_PATH,
} from 'core/cuenta/routes';
import {
  CARDS_AUTHORIZATIONS_PATH,
  CARDS_TOTALS_BY_ACCOUNT_PATH,
  CARDS_TOTALS_PATH,
  SEARCH_CARD_AUTHORIZATIONS_PATH,
  SEARCH_CARD_TOTALS_BY_PERIOD_PATH,
  SEARCH_CARD_TOTALS_PATH,
  LIST_CARDS_PATH,
  CARD_ASSOCIATE_TO_COSTCENTER,
} from 'core/tarjeta/routes';
import {
  SEARCH_BUSINESS_TOTALS_BY_PERIOD_PATH,
  SEARCH_BUSINESS_TOTALS_PATH,
  SEARCH_BUSINESS_ACCOUNT_REPORT_PATH,
  SEARCH_BUSINESS_COSTCENTRE_REPORT_PATH,
} from 'core/empresa/routes';
import {
  COST_CENTRE_LIST_BY_PERIOD_PATH,
  COST_CENTRE_LIST_PATH,
  COST_CENTRE_TOTALS_BY_ID_PATH,
  COST_CENTRE_MASS_DISTRIBUTION_PATH,
  COST_CENTRE_CREATE_PATH,
  COST_CENTRE_EDIT_PATH,
  COST_CENTRE_MOVE_PATH,
} from 'core/centrocosto/routes';
import { CONSULTAR_REPORTE_PATH } from 'core/reporte/routes';
import { AccountsTotalsPage } from 'core/cuenta/pages/AccountsTotalsPage/AccountsTotalsPage';
import { AccountsTotalsProvider } from 'core/cuenta/contexts/AccountsTotalsContext';
import { CardsTotalsByAccountProvider } from 'core/tarjeta/contexts/CardsTotalsByAccountContext';
import { CardsTotalsByAccountPage } from 'core/tarjeta/pages/CardsTotalsByAccountPage/CardsTotalsByAccountPage';
import { SearchAccountTotalsPage } from 'core/empresa/pages/SearchBusinessTotalsPage/SearchBusinessTotalsPage';
import { AccountAuthorizationsProvider } from 'core/cuenta/contexts/AccountAuthorizationsContext';
import { AccountAuthorizationPage } from 'core/cuenta/pages/AccountAuthorizationsPage/AccountAuthorizationPage';
import { CostCentreListPage } from 'core/centrocosto/pages/CostCentreListPage/CostCentreListPage';
import { CostCentreSelectorProvider } from 'core/centrocosto/contexts/CostCentreSelectorContext';
import { CostCentreTotalsProvider } from 'core/centrocosto/contexts/CostCentreTotalsContext';
import { CostCentreTotalsPage } from 'core/centrocosto/pages/CostCentreTotalsPage/CostCentreTotalsPage';
import { BusinessTotalsReportPage } from 'core/empresa/pages/BusinessTotalsReportPage/BusinessTotalsReportPage';
import { BusinessTotalsReportProvider } from 'core/empresa/contexts/BusinessTotalsReportContext';
import { AccountTotalsDataPage } from 'core/cuenta/pages/AccountTotalsDataPage/AccountTotalsDataPage';
import { AccountDetailsProvider } from 'core/cuenta/contexts/AccountDetailsContext';
import { CardTotalsSearchProvider } from 'core/tarjeta/contexts/CardTotalsSearchContext';
import { CardTotalsSearchPage } from 'core/tarjeta/pages/CardTotalSearchPage/CardTotalsSearchPage';
import { CardTotalsReportProvider } from 'core/tarjeta/contexts/CardTotalsReportContext';
import { CardTotalsReportPage } from 'core/tarjeta/pages/CardTotalsReportPage/CardTotalsReportPage';
import { CardAuthorizationsProvider } from 'core/tarjeta/contexts/CardAuthorizationsContext';
import { CardAuthorizationsPage } from 'core/tarjeta/pages/CardAuthorizationsPage/CardAuthorizationsPage';
import { CardAuthorizationsSearchProvider } from 'core/tarjeta/contexts/CardAuthorizationsSearchContext';
import { CardAuthorizationsSearchPage } from 'core/tarjeta/pages/CardAuthorizationsSearchPage/CardAuthorizationsSearchPage';
import { FundsDistributionProvider } from 'core/cuenta/contexts/FundsDistributionContext';
import { FundsDistributionPage } from 'core/cuenta/pages/FundsDistributionPage/FundsDistributionPage';
import { MassFundsDistributionPage } from 'core/centrocosto/pages/MassFundsDistributionPage/MassFundsDistributionPage';
import { MassFundsDistributionProvider } from 'core/centrocosto/contexts/MassFundsDistributionContext';
import { RefundsProvider } from 'core/cuenta/contexts/RefundsContext';
import { RefundsPage } from 'core/cuenta/pages/RefundsPage/RefundsPage';
import { TransfersProvider } from 'core/cuenta/contexts/TransfersContext';
import { TransfersPage } from 'core/cuenta/pages/TransfersPage/TransfersPage';
import { CuentaSelectorProvider } from 'core/cuenta/contexts/CuentaSelectorContext';
import { UsersListPage } from 'user/pages/UsersList/UsersListPage';
import { UserDetailPage } from 'user/pages/UserDetail/UserDetailPage';
import { CostCentreCreatePage } from 'core/centrocosto/pages/CostCentreCreatePage/CostCentreCreatePage';
import { UserInfoProvider } from 'user/context/UserInfoContext';
import { CostCentreEditPage } from 'core/centrocosto/pages/CostCentreEditPage/CostCentreEditPage';
import { CardsListPage } from 'core/tarjeta/pages/CardsListPage/CardsListPage';
import { ConsultarReportePage } from 'core/reporte/pages/ConsultarReportePage/ConsultarReportePage';
import { PasswordExpiredInfoPage } from '../../user/pages/PasswordExpiredInfoPage/PasswordExpiredInfoPage';
import { AssociateCardToCostCenterPage } from '../../core/tarjeta/pages/AssociateCardToCostCenterPage/AssociateCardToCostCenterPage';
import { UserFormPage } from 'user/pages/UserFormPage/UserFormPage';
import { CardListProvider } from 'core/tarjeta/contexts/CardListContext';
import { CostCentresListProvider } from 'core/centrocosto/contexts/CostCentreListContext';
import { CostCentreMovePage } from 'core/centrocosto/pages/CostCentreMovePage/CostCentreMovePage';

export function AppRouter() {
  return (
    <Routes>
      <Route path={LOGIN_PATH} element={<LoginPage />}></Route>

      {/* Rutas privadas */}
      <Route element={<PrivateRoute />}>
        <Route path={HOME_PATH} element={<HomePage />}></Route>
        <Route path={CONSULTAR_REPORTE_PATH} element={<ConsultarReportePage />}></Route>
        <Route path={LIST_USERS_PATH} element={<UsersListPage />}></Route>

        <Route
          path={CREATION_USERS_PATH}
          element={
            <UserInfoProvider>
              <UserFormPage />
            </UserInfoProvider>
          }
        />
        <Route
          path={LIST_CARDS_PATH}
          element={
            <CardListProvider>
              <CardsListPage />
            </CardListProvider>
          }
        ></Route>
        <Route
          path={CARD_ASSOCIATE_TO_COSTCENTER}
          element={<AssociateCardToCostCenterPage />}
        ></Route>
        <Route
          path={DETAIL_USERS_PATH}
          element={
            <UserInfoProvider>
              <UserDetailPage />
            </UserInfoProvider>
          }
        ></Route>
        <Route
          path={EDIT_USERS_PATH}
          element={
            <UserInfoProvider>
              <UserFormPage />
            </UserInfoProvider>
          }
        ></Route>
        <Route
          path={SEARCH_CARD_TOTALS_PATH}
          element={
            <CardTotalsSearchProvider>
              <CardTotalsSearchPage />
            </CardTotalsSearchProvider>
          }
        ></Route>
        <Route
          path={SEARCH_CARD_AUTHORIZATIONS_PATH}
          element={
            <CardAuthorizationsSearchProvider>
              <CardAuthorizationsSearchPage />
            </CardAuthorizationsSearchProvider>
          }
        ></Route>
        <Route
          path={SEARCH_CARD_TOTALS_BY_PERIOD_PATH}
          element={
            <CardTotalsSearchProvider>
              <CardTotalsSearchPage isPrevious />
            </CardTotalsSearchProvider>
          }
        ></Route>
        <Route
          path={SEARCH_BUSINESS_TOTALS_PATH}
          element={<SearchAccountTotalsPage />}
        ></Route>
        <Route
          path={SEARCH_BUSINESS_TOTALS_BY_PERIOD_PATH}
          element={<SearchAccountTotalsPage isPrevious />}
        ></Route>
        <Route
          path={SEARCH_BUSINESS_ACCOUNT_REPORT_PATH}
          element={
            <BusinessTotalsReportProvider>
              <BusinessTotalsReportPage />
            </BusinessTotalsReportProvider>
          }
        ></Route>
        <Route
          path={SEARCH_BUSINESS_COSTCENTRE_REPORT_PATH}
          element={
            <BusinessTotalsReportProvider>
              <BusinessTotalsReportPage />
            </BusinessTotalsReportProvider>
          }
        ></Route>
        <Route
          path={COST_CENTRE_LIST_PATH}
          element={
            <CostCentresListProvider>
              <CostCentreListPage />
            </CostCentresListProvider>
          }
        ></Route>
        <Route path={COST_CENTRE_CREATE_PATH} element={<CostCentreCreatePage />}></Route>
        <Route path={COST_CENTRE_EDIT_PATH} element={<CostCentreEditPage />}></Route>
        <Route path={COST_CENTRE_MOVE_PATH} element={<CostCentreMovePage />}></Route>
        <Route
          path={COST_CENTRE_LIST_BY_PERIOD_PATH}
          element={
            <CostCentreSelectorProvider>
              <CostCentreListPage />
            </CostCentreSelectorProvider>
          }
        ></Route>
        <Route
          path={COST_CENTRE_TOTALS_BY_ID_PATH}
          element={
            <CostCentreTotalsProvider>
              <CostCentreTotalsPage />
            </CostCentreTotalsProvider>
          }
        ></Route>
        <Route
          path={COST_CENTRE_MASS_DISTRIBUTION_PATH}
          element={
            <MassFundsDistributionProvider>
              <MassFundsDistributionPage />
            </MassFundsDistributionProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_REFUND_PATH}
          element={
            <RefundsProvider>
              <RefundsPage />
            </RefundsProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_TRANSFER_HISTORY_PATH}
          element={
            <TransfersProvider>
              <CuentaSelectorProvider>
                <TransfersPage />
              </CuentaSelectorProvider>
            </TransfersProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_DISTRIBUTION_PATH}
          element={
            <FundsDistributionProvider>
              <FundsDistributionPage />
            </FundsDistributionProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_TOTALS_PATH}
          element={
            <AccountsTotalsProvider>
              <AccountsTotalsPage />
            </AccountsTotalsProvider>
          }
        ></Route>
        <Route
          path={CARDS_TOTALS_BY_ACCOUNT_PATH}
          element={
            <CardsTotalsByAccountProvider>
              <CardsTotalsByAccountPage />
            </CardsTotalsByAccountProvider>
          }
        ></Route>
        <Route
          path={CARDS_TOTALS_PATH}
          element={
            <CardTotalsReportProvider>
              <CardTotalsReportPage />
            </CardTotalsReportProvider>
          }
        ></Route>
        <Route
          path={CARDS_AUTHORIZATIONS_PATH}
          element={
            <CardAuthorizationsProvider>
              <CardAuthorizationsPage />
            </CardAuthorizationsProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_AUTHORIZATIONS_PATH}
          element={
            <AccountAuthorizationsProvider>
              <AccountAuthorizationPage />
            </AccountAuthorizationsProvider>
          }
        ></Route>
        <Route
          path={ACCOUNT_TOTALS_BY_ACCOUNT_PATH}
          element={
            <AccountDetailsProvider>
              <AccountTotalsDataPage />
            </AccountDetailsProvider>
          }
        ></Route>
      </Route>

      <Route path={PASSWORD_EXPIRED_PATH} element={<PasswordExpiredInfoPage />} />
      <Route path={CONFIRMATION_EMAIL_PATH} element={<ConfirmationEmailPage />}></Route>
      <Route path={CHANGE_PASSWORD_PATH} element={<ChangePasswordPage />}></Route>
      <Route path={SYSTEM_ACCESS_PATH} element={<SystemAccessPage />}></Route>
      <Route path={RECOVER_PASSWORD_PATH} element={<RecoverPasswordPage />}></Route>
      <Route path={RESET_PASSWORD_PATH} element={<ResetPasswordPage />}></Route>
      <Route path={FORBIDDEN_PATH} element={<ErrorPage error="forbidden" />} />
      <Route
        path={SERVICE_UNAVAILABLE_PATH}
        element={<ErrorPage error="service_unavailable" />}
      />
      <Route path="*" element={<ErrorPage error="not_fonud" />} />
    </Routes>
  );
}
